import type { ComponentProps } from "react"
import type { SelectField } from "@motleyhand/design"
import { RadioGroupField } from "@motleyhand/design"
import FormControl from "./FormControl"

type Props = ComponentProps<typeof SelectField> & {
  name: string
  required?: boolean
  label?: string
  placeholder?: string
  helperText?: string
  options: {
    label: string
    value: string
  }[]
}

export default function FormRadioGroup({
  name,
  required,
  helperText,
  options,
  onChange,
  ...inputProps
}: Props) {
  return (
    <FormControl name={name} required={required}>
      {({ field, error, isError }) => (
        <RadioGroupField
          required={required}
          helperText={helperText}
          aria-invalid={isError}
          options={options}
          {...inputProps}
          {...field}
          onChange={(value: string) => {
            field.onChange(value)
            onChange?.(value)
          }}
          error={error}
        />
      )}
    </FormControl>
  )
}
